<template>
  <div class="map-container">
    <Map />
  </div>
</template>
<script>

import Map from '@common/components/map';

export default {
  components: {
    Map,
  },
};
</script>
<style>
.map-container {
  height: 500px;
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
}
</style>
